export default __webpack_public_path__ + "static/media/FL.2e53c0c2.png";